<div class="container-fluid full-screen p-0">
  <om-navbar-header [canGoBack]="false" [showLoginLink]="false" [showProgressBar]="false" [percentComplete]="false">
  </om-navbar-header>
</div>
<ng-container>
  <om-loading-spinner data-cy="address-suggestion-form-loading-spinner" class="mt-4"></om-loading-spinner>
</ng-container>
